/**
 * Filter steps that matches visitor type
 * @param steps
 */
const filterDuplicateFieldIdPerStep = (
  steps: any,
  formState: any,
  data: any
) => {
  return steps.map((step: any) => {
    // If visitor type is set, do the transformation. Else, return the step as it is.
    if (formState.visitortype_groups || data.currentVisitorType) {
      const fields = step.fields.map(
        (field: any, index: number, fieldArray: any) => {
          // If we are not showing it, doesn't matter.
          if (!field.showBoolean) return field;

          let indexOfFieldWithVisitorType = -1;
          let indexOfFieldWithEmptyShowIf = -1;

          fieldArray.forEach((el: any, idx: number) => {
            const showIf = JSON.parse(fieldArray[idx].show_if);
            const matchesVisitorType =
              showIf['visitortype ='] &&
              showIf['visitortype ='].includes(
                formState.visitortype_groups || data.currentVisitorType
              );
            const matchesEmptyShowIf =
              Array.isArray(showIf) && showIf.length === 0;
            const matchField = el.showBoolean && el.fieldId === field.fieldId;

            if (
              matchField &&
              matchesVisitorType &&
              indexOfFieldWithVisitorType === -1
            ) {
              indexOfFieldWithVisitorType = idx;
            }

            if (
              matchField &&
              matchesEmptyShowIf &&
              indexOfFieldWithEmptyShowIf === -1
            ) {
              indexOfFieldWithEmptyShowIf = idx;
            }
          });

          let showField = field.showBoolean;

          if (indexOfFieldWithVisitorType !== -1) {
            // If there is an index that matches the visitor type and the current index
            showField = index === indexOfFieldWithVisitorType;
          } else if (indexOfFieldWithEmptyShowIf !== -1) {
            // If there is an index that matches empty show if and the current index
            showField = index === indexOfFieldWithEmptyShowIf;
          }
          return {
            ...field,
            showBoolean: field.showBoolean && showField,
          };
        }
      );
      return Object.assign(step, { fields });
    }
    return step;
  });
};
export default filterDuplicateFieldIdPerStep;
try {
    // @ts-ignore
    filterDuplicateFieldIDPerStep.displayName = "filterDuplicateFieldIDPerStep";
    // @ts-ignore
    filterDuplicateFieldIDPerStep.__docgenInfo = { "description": "Filter steps that matches visitor type", "displayName": "filterDuplicateFieldIDPerStep", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/containers/stepContainer/dataTransform/filterDuplicateFieldIDPerStep.ts#filterDuplicateFieldIDPerStep"] = { docgenInfo: filterDuplicateFieldIDPerStep.__docgenInfo, name: "filterDuplicateFieldIDPerStep", path: "src/containers/stepContainer/dataTransform/filterDuplicateFieldIDPerStep.ts#filterDuplicateFieldIDPerStep" };
}
catch (__react_docgen_typescript_loader_error) { }